<template>
  <g-master name="greportpitem"
            :endpoint="GRPItemMaster.endpoint"
            :tableSetup="GRPItemMaster.tableSetup"
            :modalFieldsSetup="GRPItemMaster.modalFieldsSetup"
            :parentData="jbParentData"
  >
    <template slot="masterModal" slot-scope="{record}">

      <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" label="Etiqueta: " :has-feedback="false">
          <a-input
            v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </a-col>

      <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" label="Valor: " :has-feedback="false">
          <a-input
            v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </a-col>

    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['id_g_report_param'],
    computed: {
      jbParentData() {
        return {
          id_g_report_param: this.id_g_report_param
        }
      }
    },
    data() {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        GRPItemMaster: {
          endpoint: 'greportparamitem',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true},
            ]
          },
          modalFieldsSetup: [
            {name: 'value'},
            {name: 'label'},
          ]
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Greport/GreportParamItem.vue